module.exports = __webpack_public_path__ + "img/gksprwtc_beijing.45785d15.png";